import { CloseOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

/**
 * Search bar for track trigger view
 * @param allResponses - Responses without filters
 * @param setFilteredResponses - set filtered responses based on user input
 * @param className - style class for wrapper div element
 * @param placeholder - input placeholder text
 * @param setActiveFilter - flag in a parent component that indicates whether a filter is active
 * @param disabled - disable input
 **/

type Props = {
  setFilteredResponses: Dispatch<SetStateAction<any[]>>;
  allResponses: { [key: string]: any }[];
  className?: string;
  placeholder?: string;
  setActiveFilter?: Dispatch<SetStateAction<boolean>>;
  disabled?: boolean;
};
export default function FilterResultsSearchBar({
  allResponses,
  setFilteredResponses,
  className = "",
  placeholder = "Search in responses",
  setActiveFilter,
  disabled = false,
}: Props) {
  const [searchInput, setSearchInput] = useState("");
  const [totalFilteredResponses, setTotalFilteredResponses] = useState(
    allResponses.length
  );

  // function that receives user input to filter responses (response = row) that don't include this string in any question.
  const handleChange = (input: string) => {
    // if there is an active filter string and setActiveFilter was passed in, then set the "active filter" flag to true
    if (setActiveFilter) {
      setActiveFilter(Boolean(input));
    }
    setSearchInput(input);
    const filteredResponses = allResponses.filter((item) => {
      // Row will be filtered out unless a response matches the user input.
      let keepResponse = false;
      const keys: string[] = Object.keys(item);
      keys.forEach((key: string) => {
        const response = item[key];
        if (typeof response === "string") {
          if (response.toLowerCase().includes(input.toLowerCase())) {
            keepResponse = true;
          }
        }
      });
      return keepResponse;
    });
    setTotalFilteredResponses(filteredResponses.length);
    setFilteredResponses(filteredResponses);
  };

  return (
    <Tooltip
      title={
        disabled ? "Remove filters from the table to use the search box" : ""
      }
    >
      <div
        className={`text-gray-600 h-8 shadow rounded-md flex ${className} ${
          disabled ? "bg-gray-100" : ""
        }`}
      >
        <input
          type="search"
          id="trigger-track-search-bar"
          onChange={(e) => handleChange(e.target.value)}
          className=" w-4/5 p-3 h-full text-sm outline-none rounded-md	"
          placeholder={placeholder}
          value={searchInput}
          disabled={disabled}
        />
        {searchInput.length > 0 ? (
          <div className="w-1/5 h-full flex items-center justify-center pr-3">
            <CloseOutlined
              className="mr-2 cursor-pointer"
              onClick={() => {
                if (!disabled) {
                  setFilteredResponses(allResponses);
                  setSearchInput("");
                  if (setActiveFilter) {
                    setActiveFilter(false);
                  }
                }
              }}
            />
            <p className="text-xs text-gray-400 w-full m-0">{`${totalFilteredResponses}/${allResponses.length}`}</p>
          </div>
        ) : (
          <div className="w-1/5 h-full flex items-center justify-center pr-3">
            <img src="./../search.svg" alt="search" className="w-4" />
          </div>
        )}
      </div>
    </Tooltip>
  );
}
